/**
 * Converts a bore water level value (relative to ground) into a display-friendly depth value.
 *
 * Sample values from the backend (sample.rwValue) are measured relative to the ground level:
 *   - Negative values indicate water below ground (normal case).
 *   - Zero or positive values indicate water at or above ground (overflowing).
 *
 * The UI graph treats 0 as the surface and positive values as deeper measurements.
 * This function converts the relative water level to a depth value by negating the input:
 *   - Negative water levels become positive depths (e.g., -5m water level → 5m depth)
 *   - Zero water level becomes zero depth
 *   - Positive water levels become negative depths (e.g., +2m water level → -2m depth)
 *
 * Note: Pump Control UI graph works a bit differently.
 *       See `get-value-transformer-for-pump-control.ts` versus `createBoreValueTransformer`.
 *
 * @param sampleValue - Water level relative to ground
 * @returns Depth value for display (can be negative for overflowing water)
 */
const getBoreDepthLevelDisplay = (sampleValue: number): number => {
  return 0 - sampleValue;
};

export default getBoreDepthLevelDisplay;
